import React, {useContext} from 'react';
import './RestaurantSchedule.less';
import {RestaurantScheduleItem} from "compositions/restaurant-schedule-item/RestaurantScheduleItem";
import {DeliveryTypes} from "new-constants/common.constants";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";

export const RestaurantSchedule = ({scheduleDaily, deliveryType}) => {

	const isDeliveryEnabled = deliveryType !== DeliveryTypes.NO_DELIVERY && deliveryType !== DeliveryTypes.TABLE_DELIVERY;

	const translations = useContext(TranslationsContext);

	return <table className="restaurant-schedule">
		<thead>
		<RestaurantScheduleItem
			day={getSafeTranslation('restaurantSchedule.dayTitle', translations)}
			deliveryHours={isDeliveryEnabled && getSafeTranslation('restaurantSchedule.deliveryTitle', translations)}
			restaurantHours={getSafeTranslation('restaurantSchedule.restaurantTitle', translations)}
			isHeader
		/>
		</thead>
		<tbody>
		{
			scheduleDaily.map(scheduleDay => <RestaurantScheduleItem
				day={getSafeTranslation(scheduleDay.day, translations)}
				deliveryHours={isDeliveryEnabled && (scheduleDay.delivery && scheduleDay.delivery.start && scheduleDay.delivery.stop
					? `${scheduleDay.delivery.start}-${scheduleDay.delivery.stop}`
					: getSafeTranslation('restaurantSchedule.closed', translations))}
				restaurantHours={scheduleDay.pickup && scheduleDay.pickup.start && scheduleDay.pickup.stop
					? `${scheduleDay.pickup.start}-${scheduleDay.pickup.stop}`
					: getSafeTranslation('restaurantSchedule.closed', translations)}
			/>)
		}
		</tbody>
	</table>
}
